import { Dispatch, SetStateAction, useState } from 'react';

import classNames from 'classnames';
import { useTranslation } from 'hooks/useLingUI';

import { Icon, IconsEnum } from '../Icons';
import styles from './DropdownMenuFilter.module.scss';

export type DropdownMenuProps = {
  disabled?: boolean;
  listOfItems: string[];
  selectedItem?: string;
  customClassName?: string;
  translationPrefix?: string;
  handleClick?: (_activeItem: string) => void;
  setActiveTypeIndex?: Dispatch<SetStateAction<number>>;
};

export function DropdownMenuFilter({
  disabled,
  listOfItems,
  selectedItem,
  customClassName,
  translationPrefix,
  handleClick,
  setActiveTypeIndex,
}: DropdownMenuProps) {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [activeItem, setActiveItem] = useState<string>(selectedItem || listOfItems[0]);

  return (
    <div className={classNames(styles.container, customClassName)}>
      <button type="button" className={styles.button} onClick={() => setIsOpen(!isOpen)}>
        {translationPrefix ? t(`${translationPrefix}-${activeItem}`.toLowerCase(), activeItem) : activeItem}
        <Icon
          color={'var(--color-primary)'}
          iconId={IconsEnum.CHEVRON_DOWN}
          className={classNames(styles.icon, { [styles.rotate]: isOpen })}
        />
      </button>
      <ul className={classNames(styles.list, { [styles.open]: isOpen })}>
        {listOfItems?.map((item, id: number) => {
          return (
            <li
              role="button"
              className={classNames(styles.item, { [styles.active]: item === activeItem })}
              key={id}
              onClick={() => {
                if (disabled) return;
                setActiveItem(item);
                setIsOpen(false);
                if (setActiveTypeIndex) setActiveTypeIndex(id);
                if (handleClick) handleClick(item);
              }}
            >
              <button type="button" disabled={disabled} className={styles.itemButton}>
                {translationPrefix ? t(`${translationPrefix}-${item}`.toLowerCase(), item) : item}
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
